import { TranslationChunksConfig } from '@spartacus/core';
import checkoutEn from './en/checkout.json';
import checkoutEs from './es/checkout.json';

export const customCheckoutTranslationsEn = {
  checkout: checkoutEn
};

export const customCheckoutTranslationsEs = {
  checkout: checkoutEs
};

export const customCheckoutTranslationsChunksConfig: TranslationChunksConfig = {
  checkout: ['checkoutOrderConfirmation', 'checkoutShipping', 'checkout', 'checkoutPO', 'checkoutProgress', 'checkoutAddress']
};
